import { createUseStyles } from 'react-jss'

import { colors } from '../../theme'


export default createUseStyles({
  container: {
    position: 'relative',
    outline: 'none',
    '& abbr': {
      textDecoration: 'none',
    },
  },
  trigger: {
    color: colors.pureWhite,
    background: 'transparent',
    outline: '0 none',
    fontSize: '1.2rem',
    opacity: ({ isOpen }) => (isOpen ? 0 : 1),
    pointerEvents: ({ isOpen }) => (isOpen ? 'none' : 'all'),
    cursor: 'pointer',
    transition: 'opacity 300ms ease-in',
  },
  list: {
    position: 'absolute',
    top: 0,
    right: 0,
    minWidth: '9rem',
    margin: 0,
    padding: '0.5rem 0.8rem 0.8rem',
    borderRadius: '0.8rem',
    listStyle: 'none',
    textAlign: 'left',
    background: colors.pureWhite,
    opacity: ({ isOpen }) => (isOpen ? 1 : 0),
    pointerEvents: ({ isOpen }) => (isOpen ? 'all' : 'none'),
    transition: 'opacity 300ms ease-in',
    '& > *': {
      margin: 0,
    },
    '& > * + *': {
      marginTop: '0.2rem',
    },
  },
  item: {},
  link: {
    color: colors.pureBlack,
    fontSize: '1.2rem',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
})
